<div class="container-header">
  <div class="header">{{ title }}</div>
  <div class="borde"></div>
</div>
<div class="comp-container">
  <ng-container *ngIf="data">
    <ng-container *ngFor="let item of data; trackBy: trackByItem">
      <article class="lista-noticias">
        <a class="header-article" [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">
          <div class="container-img-titulo">
            <div class="image-container">
              <app-skeleton-image [src]="generateMiniSrc(item.urlGenerica)" [alt]="'Texto alternativo: ' + item.tituloVideo" [customClass]="'noticia-imagen'" [aspectRatio]="'1.1'"></app-skeleton-image>
            </div>
            <div class="title-container">
              {{ item?.tituloVideo }}
            </div>
          </div>
        </a>
      </article>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="extra">
    <div class="div-masInfo" [innerHTML]="extra"></div>
  </ng-container>
</div>
